import { StoreState } from '@/redux/types';

export function getUserDrafts(state: StoreState) {
  return state.userDrafts.drafts;
}
